module.exports = "/_next/static/images/IgorPapo-319a020015b8bd4a2b897cb280645e67.webp";